module.exports = __webpack_public_path__ + "static/img/1-12.e4f06cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/1-12.png
// module id = VDDh
// module chunks = 0